export default __webpack_public_path__ + "static/doosindoos-mobile-00430d265970dffb94df472573dcd3c6.svg";